import { stateful, useEffect, useState } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';
import * as m from '../../localization/out/messages.js';
import { getLocale, locales, setLocale } from '../../localization/out/runtime.js';

const languageLabels: Record<string, string> = {
  en: 'English',
  ja: '日本語',
  de: 'Deutsch',
  fr: 'Français',
};

const languageFlags: Record<string, string> = {
  en: '🇺🇸',
  ja: '🇯🇵',
  de: '🇩🇪',
  fr: '🇫🇷',
};

export const LanguageToggle = stateful(() => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(getLocale());

  const handleSelect = (lang: (typeof locales)[number]) => {
    void setLocale(lang);
    setCurrentLanguage(lang);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    if (!isOpen) return;

    const handleDocumentClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.language-toggle')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleDocumentClick);
    return () => document.removeEventListener('click', handleDocumentClick);
  }, [isOpen]);

  return html`
    <div class="language-toggle relative">
      <button
        @click=${toggleDropdown}
        class="flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium text-base-content/70 hover:text-primary hover:bg-base-200 transition-colors"
        .ariaLabel=${m.language_toggle_label()}
      >
        <span class="text-base">${languageFlags[currentLanguage]}</span>
        <span class="uppercase">${currentLanguage}</span>
        <span
          class="icon-[material-symbols--keyboard-arrow-down] text-base transition-transform ${isOpen
            ? 'rotate-180'
            : ''}"
        ></span>
      </button>

      ${isOpen
        ? html`
            <div
              class="absolute top-full right-0 mt-2 bg-base-100 rounded-xl shadow-lg border border-base-300 py-1 min-w-[140px] z-50"
            >
              ${locales.map(
                lang => html`
                  <button
                    @click=${() => handleSelect(lang)}
                    class="w-full flex items-center gap-2 px-3 py-2 text-sm transition-colors
                      ${lang === currentLanguage
                      ? 'text-primary bg-primary/10'
                      : 'text-base-content hover:bg-base-200'}"
                  >
                    <span class="text-base">${languageFlags[lang]}</span>
                    <span>${languageLabels[lang]}</span>
                  </button>
                `,
              )}
            </div>
          `
        : ''}
    </div>
  `;
});
